import { client, useConfig, useElementData } from '@sigmacomputing/plugin'
import { useEffect } from 'react'
import { themeOptions, themes, formatTypesNoPercent } from '../utilities'
import '../data-viz/components/PotentialValue'
  
export default function Card() {

    useEffect(() => {
        client.config.configureEditorPanel([
            {
                name: "source",
                type: "element",
            },
            {
                name: "percentage",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: 'label',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: 'Potential Value'
            },
            {
                name: "currentMemberVal",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: "activeMembers",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: "pmpy",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: 'theme',
                type: 'dropdown',
                values: themeOptions
            },
            {
                name: 'format',
                type: 'dropdown',
                values: formatTypesNoPercent
            },
            {
                name: 'helpText',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            }
        ])
    }, [])
        
    const config = useConfig()
    const sigmaData = useElementData(config.source)

    const { currentMemberVal, label, theme, format, helpText, percentage, pmpy, activeMembers } = config
    const val = (Object.keys(sigmaData).length && currentMemberVal) ? sigmaData[currentMemberVal][0] : null
    const per = (Object.keys(sigmaData).length && percentage) ? sigmaData[percentage][0] : null
    const activeMems = (Object.keys(sigmaData).length && activeMembers) ? sigmaData[activeMembers][0] : 1
    const pmpyVal = (Object.keys(sigmaData).length && pmpy) ? sigmaData[pmpy][0] : null

    return (
        <>
            <zero-potential-value
                data-fill={themes[theme]?.dark}
                data-fill2={themes[theme]?.default}
                data-bg={themes[theme]?.light}
                data-value={val}
                data-pmpy={pmpyVal}
                data-active-members={activeMems}
                data-label={label}
                data-percentage={per}
                data-format={format}
                data-help={helpText}></zero-potential-value>
        </>
    )
}
